import { FileInputField as UIFileInputField } from '../UI/Forms/FileInputField'

export const FileInputField = ({ ...props }) => {
  return <UIFileInputField {...props} variant="outlined" />
}
